var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingR1 = function SvgEarRingR1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 25,
    height: 36,
    viewBox: "0 0 0.45 0.66",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315532182608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.07.12C.13.02.4-.01.41.23c0 .15 0 .24-.17.28H.2M.06.49C.05.48.05.47.05.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.27.22C.21.19.08.26.18.29.24.31.24.36.15.36.14.36.12.37.11.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.17.45c.05.03.07.08.06.12C.23.6.21.62.19.64.16.66.13.67.1.66.06.66.02.63.01.57-.02.49.02.47.07.45.08.44.1.44.11.43c.02 0 .04.01.06.02zM.13.51C.21.56.1.64.08.55.07.53.09.52.11.51h.02z",
    fill: "#000"
  })))));
};

export default SvgEarRingR1;